<template>
  <body>
    <div class="booking_information">预订须知</div>
    <div v-html="part_content" class="part_content"></div>
  </body>
</template>
  
<script>
export default {
  name: 'BookingInformation',
  componentName: 'BookingInformation',
  data() {
    return {
      part_content:'',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const url = 'webpart/info/attention'
      var param = {}
      var webPartInfo = this.$myGet(url, param)
      webPartInfo.then(res => {
        const reData = res.response.data
        const rcode = reData.rcode
        if (rcode == 0) {
          this.part_content = reData.data.part_content
        }
      })
      .catch(err => {
        console.log('err:' + err)
      })
    }
  }

}

</script>
<style scoped>
.booking_information {
  font-size: 1.5em;
  line-height: 180%;
  font-weight: bold;
  text-align: center;
}
.part_content {
  padding: 2%;
  line-height: normal;
  font-size: 1.3em;
  margin: 2%;
}
body {
  line-height: 150%;
  padding: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/route/bookingInformation.vue